import { useState } from 'react';
import { Zap } from 'lucide-react';
import useCreditPacks from '../../hooks/useCreditPacks';
import PackBoosterCheckoutModal from '../stripe/PackBoosterCheckoutModal';

/**
 * BuyPackButton — always-visible purchase entry point for the Ma Thématique
 * Pack Booster. Meant to sit next to quota counters / header so users can buy
 * preventively, independently of the contextual PackBoosterCTA (which only
 * appears near/above quota thresholds).
 *
 * Renders nothing if no active offer is configured admin-side.
 */
export default function BuyPackButton({ thematiqueId, onPurchased, compact = false }) {
    const packs = useCreditPacks(thematiqueId);
    const [open, setOpen] = useState(false);

    if (!packs.defaultOffer) return null; // no active Booster offer → hide

    return (
        <>
            <button
                className={compact ? 'buy-pack-btn buy-pack-btn--compact' : 'buy-pack-btn'}
                onClick={() => setOpen(true)}
                title={packs.defaultOffer.description || 'Un Pack IA = capacité étendue de la thématique + nouveaux crédits de génération IA'}
            >
                <Zap size={13} />
                <span>+ Pack IA</span>
            </button>
            {open && (
                <PackBoosterCheckoutModal
                    thematiqueId={thematiqueId}
                    offers={packs.offers}
                    priceEur={packs.priceEur}
                    content={packs.content}
                    onClose={() => setOpen(false)}
                    onSuccess={() => { packs.reload(); onPurchased?.(); }}
                />
            )}
        </>
    );
}
